export interface CountryData {
  id: string;
  name: string;
  aphaThreeCode: string;
  numericCode: number;
  nationality: string;
}

export const initialCountryData: CountryData = {
  id: "",
  name: "",
  aphaThreeCode: "",
  numericCode: 0,
  nationality: "",
};
